export function jsonParse(string) {
  try {
    return JSON.parse(string);
  } catch (error) {
    return null;
  }
}

export function tokenDateIsValid(exp) {
  return ((new Date()) < new Date(exp * 1000))
}